import { render } from "./ContractList.vue?vue&type=template&id=24af3232"
import script from "./ContractList.vue?vue&type=script&lang=js"
export * from "./ContractList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__